<template>
  <Cascader
    v-model="info.defaultValue"
    :disabled="info.form.disabled||!info.isNew"
    :placeholder="info.form.placeholder"
    :clearable="info.form.clearable"
    :filterable="info.form.filterable"
    :size="size"
    :data="info.form.options.staticList"></Cascader>
</template>
<script>
import { baseComponentMixins } from '../mixins'

export default {
  name: 'BaseCascader',
  mixins: [ baseComponentMixins ],
  created() {
    const { defaultValue } = this.info
    if (!(defaultValue instanceof Array)) {
      this.info.defaultValue = defaultValue ? defaultValue.split(',') : []
    }
  },
}
</script>